import { EventEmitter } from '@angular/core';
import { GenericListSlideToggleClickHandlerData } from './generic-list-slide-toggle-click-handler-data';

export class GenericListSlideToggleDefinition {
  label: string;
  clickHandler: EventEmitter<GenericListSlideToggleClickHandlerData>;
  data: any;
  state = false;
  disabled = false;
  color = 'primary';
  classes: string;

  constructor(
    label: string,
    clickHandler: EventEmitter<GenericListSlideToggleClickHandlerData>,
    data: any,
    state?: boolean,
    disabled?: boolean,
    color?: string,
    classes?: string
  ) {
    this.label = label;
    this.classes = classes;
    this.clickHandler = clickHandler;
    this.data = data;
    this.state = state;
    this.disabled = disabled;
    this.color = color;
  }
}
